import React, { useState } from 'react';
import { motion } from 'framer-motion';
import iconFilter from '../assets/icon/general/filtri.png';
import ACTIVITY_OPTIONS from '../components/utils/ActivityOptions';

const FilterDropdown = ({ options = ACTIVITY_OPTIONS, onFilterChange }) => {
  const [open, setOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);

  const toggleDropdown = () => setOpen(!open);

  const handleCheckboxChange = (option) => {
    const isSelected = selectedValues.includes(option.value);
    const updated = isSelected
      ? selectedValues.filter((val) => val !== option.value)
      : [...selectedValues, option.value];

    setSelectedValues(updated);
    onFilterChange?.(updated);
  };

  return (
    <div className="relative inline-block text-left border border-secondary rounded-full">
      <button onClick={toggleDropdown} className="p-2 rounded-xl shadow-md hover:bg-gray-100">
        <img src={iconFilter} alt="Filtri" className="w-6 h-6" />
      </button>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="absolute top-full left-0 mt-2 w-52 rounded-2xl shadow-lg bg-primary ring-1 ring-black ring-opacity-5 z-50 p-4"
        >
          <div className="flex flex-col gap-2">
            {options.map((option) => (
              <label key={option.value} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={selectedValues.includes(option.value)}
                  onChange={() => handleCheckboxChange(option)}
                />
                <span className="text-sm text-white">{option.label}</span>
              </label>
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default FilterDropdown;
